module.exports = __webpack_public_path__ + "img/drawer_background.6a9cfa7b.svg";